import {
  SiteColors,
  SiteStyles,
  SiteTextPresets,
  StyleParams,
} from '@wix/cashier-common/dist/src/types/SiteStyles';

export const DEFAULT_SITE_COLORS: SiteColors = [
  { name: 'color_1', value: '#FFFFFF', reference: 'white/black' },
  { name: 'color_2', value: '#000000', reference: 'black/white' },
  { name: 'color_3', value: '#ED1C24', reference: 'primery-1' },
  { name: 'color_4', value: '#0088CB', reference: 'primery-2' },
  { name: 'color_5', value: '#FFCB05', reference: 'primery-3' },
  { name: 'color_11', value: '#FFFFFF', reference: 'color-1' },
  { name: 'color_12', value: '#E8E6E6', reference: 'color-2' },
  { name: 'color_13', value: '#C7C7C7', reference: 'color-3' },
  { name: 'color_14', value: '#757575', reference: 'color-4' },
  { name: 'color_15', value: '#000000', reference: 'color-5' },
  { name: 'color_16', value: '#B5BCF0', reference: 'color-6' },
  { name: 'color_17', value: '#8F98E2', reference: 'color-7' },
  { name: 'color_18', value: '#338FFC', reference: 'color-8' },
  { name: 'color_19', value: '#25318D', reference: 'color-9' },
  { name: 'color_20', value: '#131946', reference: 'color-10' },
  { name: 'color_21', value: '#F9C5B4', reference: 'color-11' },
  { name: 'color_22', value: '#F3A78F', reference: 'color-12' },
  { name: 'color_23', value: '#ED5829', reference: 'color-13' },
  { name: 'color_24', value: '#9E3B1B', reference: 'color-14' },
  { name: 'color_25', value: '#4F1D0E', reference: 'color-15' },
  { name: 'color_26', value: '#D2ACF7', reference: 'color-16' },
  { name: 'color_27', value: '#BA83F0', reference: 'color-17' },
  { name: 'color_28', value: '#8015E8', reference: 'color-18' },
  { name: 'color_29', value: '#550E9B', reference: 'color-19' },
  { name: 'color_30', value: '#2B074D', reference: 'color-20' },
  { name: 'color_31', value: '#B1D3BB', reference: 'color-21' },
  { name: 'color_32', value: '#7FA88B', reference: 'color-22' },
  { name: 'color_33', value: '#407C51', reference: 'color-23' },
  { name: 'color_34', value: '#2B5336', reference: 'color-24' },
  { name: 'color_35', value: '#15291B', reference: 'color-25' },
];

export const DEFAULT_SITE_TEXT_PRESETS: SiteTextPresets = {
  Title: {
    editorKey: 'font_0',
    fontFamily: 'proxima-n-w01-reg,sans-serif',
    lineHeight: '1.4em',
    size: '60px',
    style: 'normal',
    value: 'font:normal normal normal 60px/1.4em proxima-n-w01-reg,sans-serif;',
    weight: 'normal',
  },
  Menu: {
    editorKey: 'font_1',
    fontFamily:
      'din-next-w01-light,din-next-w02-light,din-next-w10-light,sans-serif',
    lineHeight: '1.4em',
    size: '16px',
    style: 'normal',
    value:
      'font:normal normal normal 16px/1.4em din-next-w01-light,din-next-w02-light,din-next-w10-light,sans-serif;',
    weight: 'normal',
  },
  'Page-title': {
    editorKey: 'font_2',
    fontFamily: 'proxima-n-w01-reg,sans-serif',
    lineHeight: '1.4em',
    size: '40px',
    style: 'normal',
    value: 'font:normal normal normal 40px/1.4em proxima-n-w01-reg,sans-serif;',
    weight: 'normal',
  },
  'Heading-XL': {
    editorKey: 'font_3',
    fontFamily: 'proxima-n-w01-reg,sans-serif',
    lineHeight: '1.4em',
    size: '32px',
    style: 'normal',
    value: 'font:normal normal normal 32px/1.4em proxima-n-w01-reg,sans-serif;',
    weight: 'normal',
  },
  'Heading-L': {
    editorKey: 'font_4',
    fontFamily: 'proxima-n-w01-reg,sans-serif',
    lineHeight: '1.4em',
    size: '28px',
    style: 'normal',
    value: 'font:normal normal normal 28px/1.4em proxima-n-w01-reg,sans-serif;',
    weight: 'normal',
  },
  'Heading-M': {
    editorKey: 'font_5',
    fontFamily: 'proxima-n-w01-reg,sans-serif',
    lineHeight: '1.4em',
    size: '25px',
    style: 'normal',
    value: 'font:normal normal normal 25px/1.4em proxima-n-w01-reg,sans-serif;',
    weight: 'normal',
  },
  'Heading-S': {
    editorKey: 'font_6',
    fontFamily: 'proxima-n-w01-reg,sans-serif',
    lineHeight: '1.4em',
    size: '22px',
    style: 'normal',
    value: 'font:normal normal normal 22px/1.4em proxima-n-w01-reg,sans-serif;',
    weight: 'normal',
  },
  'Body-L': {
    editorKey: 'font_7',
    fontFamily: 'proxima-n-w01-reg,sans-serif',
    lineHeight: '1.4em',
    size: '17px',
    style: 'normal',
    value: 'font:normal normal normal 17px/1.4em proxima-n-w01-reg,sans-serif;',
    weight: 'normal',
  },
  'Body-M': {
    editorKey: 'font_8',
    fontFamily: 'proxima-n-w01-reg,sans-serif',
    lineHeight: '1.4em',
    size: '15px',
    style: 'normal',
    value: 'font:normal normal normal 15px/1.4em proxima-n-w01-reg,sans-serif;',
    weight: 'normal',
  },
  'Body-S': {
    editorKey: 'font_9',
    fontFamily: 'proxima-n-w01-reg,sans-serif',
    lineHeight: '1.4em',
    size: '14px',
    style: 'normal',
    value: 'font:normal normal normal 14px/1.4em proxima-n-w01-reg,sans-serif;',
    weight: 'normal',
  },
  'Body-XS': {
    editorKey: 'font_10',
    fontFamily:
      'din-next-w01-light,din-next-w02-light,din-next-w10-light,sans-serif',
    lineHeight: '1.4em',
    size: '12px',
    style: 'normal',
    value:
      'font:normal normal normal 12px/1.4em din-next-w01-light,din-next-w02-light,din-next-w10-light,sans-serif;',
    weight: 'normal',
  },
};

export const DEFAULT_STYLE_PARAMS: StyleParams = {
  colors: {},
  numbers: {},
  booleans: {},
  fonts: {},
  googleFontsCssUrl: '',
  uploadFontFaces: '',
};

export const DEFAULT_SITE_STYLES: SiteStyles = {
  siteColors: DEFAULT_SITE_COLORS,
  siteTextPresets: DEFAULT_SITE_TEXT_PRESETS,
  styleParams: DEFAULT_STYLE_PARAMS,
};
